<button class="games-btn"
        [class.is-loading]="showLoader"
        (click)="handleClick()"
        [disabled]="disabledInner || showLoader">
        <span>
            <ng-content></ng-content>
        </span>
        <div class="loader-btn-wrapper">
            <div *ngIf="showLoader" class="loader-btn"></div>
        </div>
</button>

